import React from 'react';

import Video from 'components/Video/Video';
import { VideoComponentType } from 'utils/sharedStrapiQueries/sharedTypes';

import * as S from './ArticleVideo.styles';

export interface ArticleVideoProps {
  data: VideoComponentType;
  className?: string;
}

const defaultProps: Partial<ArticleVideoProps> = {};

const ArticleVideo: React.FunctionComponent<ArticleVideoProps> = ({
  data,
  className,
}) => {
  return (
    <S.ArticleVideoWrapper className={className}>
      <Video
        video={data.video}
        errorMessage={data.errorMessage}
        videoType={data.videoType}
      />
    </S.ArticleVideoWrapper>
  );
};

ArticleVideo.defaultProps = defaultProps;

export default ArticleVideo;
